import React from "react";
import "../assets/diff.css";

function DiffModal({ history, onClose }) {
  if (!history) return null;

  let oldData = {};
  let newData = {};

  try {
    oldData = JSON.parse(history.old_data || "{}");
    newData = JSON.parse(history.new_data || "{}");
  } catch (e) {
    console.error("Diff parse error", e);
  }

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-box">
        <h5>History ID: {history.id}</h5>
        <p className="text-muted">Reason: {history.reason}</p>

        <div className="row">
          <div className="col-md-6">
            <h6 className="text-danger">Old Data</h6>
            <pre className="diff-box">{JSON.stringify(oldData, null, 2)}</pre>
          </div>

          <div className="col-md-6">
            <h6 className="text-success">New Data</h6>
            <pre className="diff-box">{JSON.stringify(newData, null, 2)}</pre>
          </div>
        </div>

        <button className="btn btn-dark mt-3" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default DiffModal;